import { some, startsWith } from 'lodash';
import { isRootNode } from '../common/components/dataViews/DynamicTree';
const PROGRAM = 'Program';
const PROGRAM_FOLDER = 'ProgramFolder';
export function isProgram({ __typename }) {
    return __typename === PROGRAM;
}
export function isProgramFolder({ __typename }) {
    return __typename === PROGRAM_FOLDER;
}
export function resolveNodeId(node) {
    if (isProgram(node)) {
        return `${PROGRAM}-${node.id}`;
    }
    if (isProgramFolder(node)) {
        return `${PROGRAM_FOLDER}-${node.id}`;
    }
    return node.id;
}
export function resolveNodeParentId(node) {
    if (isProgram(node) && node.programFolderId) {
        return `${PROGRAM_FOLDER}-${node.programFolderId}`;
    }
    if (isProgramFolder(node) && node.parentId) {
        return `${PROGRAM_FOLDER}-${node.parentId}`;
    }
    return null;
}
export const resolveNodeClassName = node => {
    switch (true) {
        case isRootNode(node):
            return 'jstree-node-bold';
        case isProgram(node):
            return 'jstree-node-italic';
        default:
            return '';
    }
};
export function nodeIsLeaf(node) {
    return isProgram(node);
}
export const canRender = ({ id, model, leaf, nodesMeta: { hasChild }, state, }) => {
    const checkLeafExistsRecursively = (nodeId) => {
        if (!state.children[nodeId] || !state.children[nodeId].length) {
            return false;
        }
        const leafExists = some(state.children[nodeId], str => startsWith(str, `${PROGRAM}-`));
        if (leafExists) {
            return true;
        }
        return some(state.children[nodeId], childId => checkLeafExistsRecursively(childId));
    };
    if ((model.id !== ':ROOT:' || model.id !== null) && !nodeIsLeaf(model)) {
        if (state.children[id]) {
            const leafExists = checkLeafExistsRecursively(id);
            if (!leafExists || leaf) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
};
